//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import mixin from './mixin'
export default {
    mixins: [
        mixin
    ],
    methods: {
        back () {
            this.$router.back()
        }
    }
}
